import { t } from "i18n-js";
import basicRequest from "../../../core/redux/actions/request";

const PREFIX = "PAYMENT_SHOW";
const getState = (state) => state.payment.show;

const {
    getPattern,

    actionPostPattern,
    actionPutPattern,

    reset,

    isLoaded,
    isLoading,
    getError,
    getData,
} = basicRequest(PREFIX, getState);

export const load = (id) => getPattern("react/v1/payments/" + id, {}, null);

export { reset, isLoading, isLoaded, getError, getData };
